import { ROLES } from "../config/roles";

// Set to true if staff should also be allowed to delete employees.
// Keep this in sync with STAFF_CAN_DELETE in backend/middleware/roleGuard.js
export const STAFF_CAN_DELETE = false;

export const getRole = () => localStorage.getItem("role");

export const isStaffUser = () => getRole() === ROLES.STAFF;

// Salary + hourly rate are visible / editable only for non-staff users
export const canSeeSalary = () => !isStaffUser();

// Staff cannot assign roles (otherwise they could create an Admin account)
export const canChangeRole = () => !isStaffUser();

export const canDeleteEmployee = () => !isStaffUser() || STAFF_CAN_DELETE;

// Staff cannot edit Admin accounts (backend enforces the same rule)
export const canEditEmployee = (employee) =>
  !(isStaffUser() && employee?.role === "Admin");